module.exports = __webpack_public_path__ + "img/bicycleFrontRight.cdc994e1.svg";